if (!customElements.get('ugc-product-quick-view')) {
  class UGCProductQuickView extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.ugc-qv-content');
      this.videoUrl = null;
    }

    open(handle, videoUrl) {
      this.videoUrl = videoUrl;
      this.setAttribute('aria-hidden', 'false');
      this.classList.add('is-active');

      fetch(`/products/${handle}?section_id=ugc-product-quickview`)
        .then(res => res.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const section = doc.querySelector('.shopify-section');

          this.content.innerHTML = section.innerHTML;
          this.injectVideo();
        });
    }

    injectVideo() {
      const video = this.querySelector('.ugc-qv-video');
      if (!video || !this.videoUrl) return;

      video.src = this.videoUrl;
      video.currentTime = 0;
      video.play().catch(() => {});
    }

    close() {
      const video = this.querySelector('.ugc-qv-video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
      }

      this.classList.remove('is-active');
      this.setAttribute('aria-hidden', 'true');
      this.content.innerHTML = '';
    }

    connectedCallback() {
      this.addEventListener('click', e => {
        if (
          e.target.classList.contains('ugc-qv-overlay') ||
          e.target.classList.contains('ugc-qv-close')
        ) {
          this.close();
        }
      });
    }
  }

  customElements.define('ugc-product-quick-view', UGCProductQuickView);
}
